import axios from "axios";
import store from "../store";

const getSession = () => {
  try {
    return (
      store.state.current_user?.email || store.state.current_user?.name || ""
    );
  } catch (error) {
    return `error: ${error}`;
  }
};

export const CSApi = (headers) => {
  return axios.create({
    baseURL: process.env.VUE_APP_CS_API_URL,
    headers: {
      Authorization: process.env.VUE_APP_CS_COVERAGE_TOKEN,
      "user-session": getSession(),
      ...headers,
    },
  });
};
